const $ = require('cash-dom');

$(function () {
	const $showAccessibilityButton = $('#show-accessibility-button');

	if ($showAccessibilityButton.length) {
		require("../../vendor/sienna.min");
	}

	// we use setInterval() because the button is not on page immediately
	const intervalId = setInterval(() => {
		const $accessibilityWidgetButton = $('.asw-widget .asw-menu-btn');

		if ($accessibilityWidgetButton.length) {
			$accessibilityWidgetButton.attr('data-btn-name', 'accessibility-widget');
			clearInterval(intervalId);
		}
	}, 50);
});
